var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-main",style:(_vm.contStyles)},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showImage),expression:"showImage"}],style:(_vm.styles),attrs:{"src":_vm.imgSrc}}),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVideo),expression:"showVideo"}],ref:"videoPlayer",style:(_vm.styles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }